import type { Constituent, MaterialNodeSpec } from './types';

const MAX_TERMS = 3;
const SEPARATOR = ' + ';
const OVERFLOW = ' + ...';

/**
 * Generate a material node display label from its constituents.
 *
 * Rules:
 * - Empty → ""
 * - Single → the name
 * - Multiple → top 3 by weight descending, joined with " + "
 * - More than 3 → append " + ..."
 */
export function generateMaterialLabel(constituents: Constituent[]): string {
  if (constituents.length === 0) return '';
  if (constituents.length === 1) return constituents[0].name;

  const sorted = [...constituents].sort((a, b) => b.weight - a.weight);
  const top = sorted.slice(0, MAX_TERMS).map((c) => c.name);
  const base = top.join(SEPARATOR);
  return sorted.length > MAX_TERMS ? base + OVERFLOW : base;
}

/**
 * Returns the label to display on the material node's hexagon.
 * Always returns spec.name — the user-authored label is the display label.
 */
export function resolveMaterialLabel(spec: MaterialNodeSpec): string {
  return spec.name;
}
